<template>
  <div class="reporting-item">
    <div class="dashboard-stat primary" style=" padding: 25px 10px;" @click.stop="click">
      <div class="details">
        <span>
            <calendar-check-icon v-if="isTaskType" class="icon"></calendar-check-icon>
            <home-icon v-if="isMortgageType" class="icon"></home-icon>
            <umbrella-icon v-if="isPolicyType" class="icon"></umbrella-icon>
        </span>
        <div class="content" style="margin: 0;" :title="title">
          {{ title }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "ReportingTypeButton",
  props: {
    type: {
      required: true,
      type: String
    },
    path: {
      required: true,
      type: String
    },
    title: {
      required: true,
      type: String
    }
  },
  computed: {
    isTaskType() {
      return (this.type === 'task');
    },
    isMortgageType() {
      return (this.type === 'mortgage');
    },
    isPolicyType() {
      return (this.type === 'policy');
    }
  },

  methods: {
    click() {
      this.navigator.navigate(this.path);
    }
  }
}
</script>

<style scoped>
.details .icon {
  font-size: 30px;
}

.reporting-item {
  float: left;
  width: 33.33%;
  padding: 1rem 2rem;
  cursor: pointer;
}
</style>
